(() => {
  if (customElements.get('tbhnp-product-callouts')) return;
  class ProductCallouts extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true; this.cleanups = [];
      let data;
      try { data = JSON.parse(this.querySelector('script').textContent); } catch { return; }
      const section = this.closest('.shopify-section');
      const component = section?.querySelector('tbhnp-mobile-product-slide');
      if (!component) return;
      data.views.forEach(view => {
        const host = [...component.querySelectorAll('[data-media-slide]')].find(el => el.dataset.mediaId === String(view.mediaId));
        if (host) this.mount(component, host, view);
      });
    }
    disconnectedCallback() { this.cleanups?.forEach(fn => fn()); this.ready = false; }
    mount(component, host, view) {
      const img = host.querySelector('.tbhnp-mobile-pdp__media-image:not([data-gallery-preview-image])');
      if (!img || !view.labels?.length || host.querySelector('.tbhnp-callout-layer')) return;
      host.classList.add('tbhnp-callout-host');
      const layer = document.createElement('div'); layer.className = 'tbhnp-callout-layer';
      const ns = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(ns,'svg'); svg.setAttribute('aria-hidden','true'); layer.append(svg);
      const items = view.labels.map((item,i) => {
        const group = document.createElementNS(ns,'g'); group.style.setProperty('--callout-delay',`${i*.3}s`);
        const path = document.createElementNS(ns,'path'); path.setAttribute('pathLength','1');
        const circle = document.createElementNS(ns,'circle'); circle.setAttribute('r','2.5');
        group.append(path,circle); svg.append(group);
        const label = document.createElement('span'); label.className = 'tbhnp-callout-label'; label.textContent = item.text; label.style.setProperty('--callout-delay',`${i*.3}s`); layer.append(label);
        return {...item,path,circle,label};
      });
      host.append(layer);
      let frame = 0, started = false;
      const track = host.parentElement;
      const layout = () => {
        frame = 0;
        const hr = host.getBoundingClientRect(), tr = track.getBoundingClientRect();
        const imageReady = img.naturalWidth > 10 && img.complete && (!img.hasAttribute('data-gallery-ready') || img.dataset.galleryReady === 'true');
        if (!imageReady || !hr.width || !hr.height || component.classList.contains('tbhnp-mobile-pdp--hero-pending') || hr.right <= tr.left+1 || hr.left >= tr.right-1) {
          layer.classList.remove('is-ready'); return;
        }
        // Keep the gallery's existing stacking/arrival transforms intact.
        const sx = hr.width / host.offsetWidth, sy = hr.height / host.offsetHeight;
        if (Math.abs(sx-1)>.01 || Math.abs(sy-1)>.01) { layer.classList.remove('is-ready'); return; }
        const edge = hr.width < 500 ? 16 : 24;
        items.forEach((item,i) => {item.label.style.left=i===1?'auto':edge+'px';item.label.style.right=i===1?edge+'px':'auto';});
        let safeTop = 12, safeBottom = hr.height-16;
        const header = component.querySelector('.tbhnp-mobile-reel__header')?.getBoundingClientRect();
        if (header?.height) safeTop = Math.max(safeTop,header.bottom-hr.top+12);
        if (['64290211627192','64290316157112','64319359844536','64319359877304','64318895489208','64318895587512'].includes(String(view.mediaId))) {
          const utility = document.querySelector('.tbhnp-mobile-global-header__utility-pill')?.getBoundingClientRect();
          if (utility?.width && utility.height && utility.bottom > hr.top && utility.top < hr.bottom && utility.right > hr.left && utility.left < hr.right) {
            safeTop = Math.max(safeTop, utility.bottom - hr.top + 12);
          }
        }
        component.querySelectorAll('.tbhnp-mobile-pdp__media-pagination,[data-pullbar]').forEach(el => {
          const r = el.getBoundingClientRect();
          if (r.width && r.height && r.top>hr.top && r.top<hr.bottom) safeBottom=Math.min(safeBottom,r.top-hr.top-12);
        });
        const topHeight = Math.max(...items.slice(0,2).map(item=>item.label.offsetHeight));
        const bottomHeight = items[2]?.label.offsetHeight || 0;
        const garmentMin = safeTop+topHeight+26, garmentMax = safeBottom-(bottomHeight?bottomHeight+26:0);
        const bounds = view.bounds;
        host.style.setProperty('--callout-scale','1'); host.style.setProperty('--callout-shift','0px');
        let ir=img.getBoundingClientRect();
        const originalFit=Math.min(ir.width/img.naturalWidth,ir.height/img.naturalHeight);
        const occupiedHeight=originalFit*img.naturalHeight*(bounds[3]-bounds[1]);
        const shrink=Math.min(1,Math.max(30,garmentMax-garmentMin)/Math.max(1,occupiedHeight));
        host.style.setProperty('--callout-scale',String(shrink));
        ir=img.getBoundingClientRect();
        const fit=Math.min(ir.width/img.naturalWidth,ir.height/img.naturalHeight),iw=img.naturalWidth*fit,ih=img.naturalHeight*fit;
        let oy=ir.top-hr.top+(ir.height-ih)/2;
        const shift=Math.max(garmentMin-(oy+ih*bounds[1]),Math.min(0,garmentMax-(oy+ih*bounds[3])));
        host.style.setProperty('--callout-shift',shift+'px'); ir=img.getBoundingClientRect();
        const ox=ir.left-hr.left+(ir.width-iw)/2; oy=ir.top-hr.top+(ir.height-ih)/2;
        const top=oy+ih*bounds[1],bottom=oy+ih*bounds[3];
        items.forEach((item,i) => {
          const right=i===1,lh=item.label.offsetHeight;
          const y=i===2?Math.min(safeBottom-lh,bottom+26):Math.max(safeTop,top-lh-26);
          item.label.style.top=y+'px';
          const lr=item.label.getBoundingClientRect(),ax=ox+item.x*iw,ay=oy+item.y*ih;
          const tx=right?lr.right-hr.left:lr.left-hr.left,ty=i===2?y-10:y+lh+10;
          const bx=right?Math.max(ax+12,tx-28):Math.min(ax-12,tx+28);
          item.path.setAttribute('d',`M ${ax} ${ay} L ${bx} ${ay} L ${tx} ${ty}`); item.circle.setAttribute('cx',ax);item.circle.setAttribute('cy',ay);
        });
        layer.classList.add('is-ready');
        const visibleWidth=Math.min(hr.right,tr.right)-Math.max(hr.left,tr.left);
        if (!started && visibleWidth>hr.width*.5) {layer.classList.add('is-playing');started=true;}
      };
      const schedule=()=>{if(!frame)frame=requestAnimationFrame(layout);};
      const resize=new ResizeObserver(schedule); [host,img,...component.querySelectorAll('.tbhnp-mobile-pdp__media-pagination,[data-pullbar]')].forEach(el=>resize.observe(el));
      const mutation=new MutationObserver(schedule); mutation.observe(component,{attributes:true,attributeFilter:['class']});mutation.observe(img,{attributes:true,attributeFilter:['src','srcset','class','data-gallery-ready']});
      const intersection=new IntersectionObserver(schedule,{root:track,threshold:[0,.5,1]});intersection.observe(host);
      track.addEventListener('scroll',schedule,{passive:true});component.addEventListener('transitionend',schedule);img.addEventListener('load',schedule);window.addEventListener('resize',schedule);window.visualViewport?.addEventListener('resize',schedule);
      schedule();
      this.cleanups.push(()=>{cancelAnimationFrame(frame);resize.disconnect();mutation.disconnect();intersection.disconnect();track.removeEventListener('scroll',schedule);component.removeEventListener('transitionend',schedule);img.removeEventListener('load',schedule);window.removeEventListener('resize',schedule);window.visualViewport?.removeEventListener('resize',schedule);host.style.removeProperty('--callout-scale');host.style.removeProperty('--callout-shift');host.classList.remove('tbhnp-callout-host');layer.remove();});
    }
  }
  customElements.define('tbhnp-product-callouts',ProductCallouts);
})();
